import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';



@Injectable()
export class ControlsService {

  freeControlSubject: BehaviorSubject<Boolean> =  new BehaviorSubject<Boolean>(false);
  recentControlSubject: BehaviorSubject<Boolean> =  new BehaviorSubject<Boolean>(false);
  licenseModalControlSubject: BehaviorSubject<any> =  new BehaviorSubject<any>({});

  constructor() { }

  public getFreeControlSubject(): Subject<any> {
    return this.freeControlSubject;
  }

  public setFreeControlSubject(query: any): void {
    this.freeControlSubject.next(query);
  }

  public getRecentControlSubject(): Subject<any> {
    return this.recentControlSubject;
  }

  public setRecentControlSubject(query: any): void {
    this.recentControlSubject.next(query);
  }

  public getLicenseModalControlSubject(): Subject<any> {
    return this.licenseModalControlSubject;
  }

  public setLicenseModalControlSubject(data: any): void {
    this.licenseModalControlSubject.next(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/controls.service.ts